<template>
  <form @submit.prevent="submitSurvey">
    <div class="card-body">
      <div class="row">
        <Input
            containerClass="col-12 mb-6"
            name="name"
            :label="$t('label.title')"
            :placeholder="$t('label.title')"
            v-model="formData.name"
        />
        <div class="row">
          <div class="col-4">
            <Input
                containerClass="col-12 mb-6"
                name="name"
                :label="$t('label.population_question')"
                :placeholder="$t('label.population_question')"
                v-model="formData.questions"
                :isRequired="false"
            />
          </div>
          <div class="col-4">
            <Select2
                container-class="form-group col-12"
                :multiple="true"
                :show-search="true"
                :selectClass="'form-select form-control-sm form-select-solid'"
                :name="`populations${id}`"
                :label="$t('label.population')"
                labelClass="form-label fs-6 text-black"
                :placeholderText="$t('label.population')"
                v-model="formData.population_ids"
                :IsInputGroup ="true"
                icon="bi bi-plus"
                :isRequired="false"
                :clickAddon="openCreatePopulationModal">
              <option v-for="population in populations" :key="population.id" :value="population.id">
                {{ population.name }}
              </option>
            </Select2>
          </div>
          <div class="col-4 d-flex p-0">
            <InputDate
                size="lg"
                id="start_date"
                containerClass="col-6 mb-6 me-2 "
                name="start_date"
                :placeholder="$t('label.start_date')"
                :label="$t('label.start_date')"
                :minDate="minDate"
                :isRequired="true"
                v-model="formData.start_date"
            />
            <InputDate
                size="lg"
                containerClass="col-6 mb-6"
                id="end_date"
                name="end_date"
                :placeholder="$t('label.end_date')"
                :label="$t('label.end_date')"
                :minDate="minDate"
                v-model="formData.end_date"
            />
          </div>
        </div>
        <TextArea
            :label="$t('label.description')"
            :placeholder="$t('label.description')"
            :rows="3"
            :isRequired="false"
            v-model="formData.description"
        />


        <CreateQvctPopulations
            id="create_qvct_population"
            @reload="reload"
        />
      </div>
    </div>
    <div class="card-footer py-3 d-flex justify-content-end">
      <button type="button" @click.prevent="router.back()" class="btn py-2 btn-light me-4">
        {{ $t('button.close') }}
      </button>
      <Button :is-loading="isLoading" type="submit" btnClass="btn py-2 btn-primary" :btn-text="$t('button.save')"/>
    </div>
  </form>
</template>
<script setup>
import TextArea from "@/components/TextArea.vue";
import Input from "@/components/Input.vue";
import InputDate from "@/components/InputDate.vue";
import Select2 from "@/components/Select2.vue";
import {computed, onMounted, ref, watch} from "vue";
import {useStore} from "vuex";
import {useRoute, useRouter} from "vue-router";
import Button from "@/components/Button.vue";
import CreateQvctPopulations from "@/Modules/Qvct/components/CreateQvctPopulations.vue";

const store = useStore()

const route = useRoute()
const router = useRouter()

const isLoading = ref(false)

const formData = ref({
  id: null,
  name: "",
  questions: "",
  start_date: "",
  end_date: "",
  description: "",
  population_ids :[]
})

const survey = computed(() => store.getters['qvctSurvey/getQvctSurvey'](route.params.id))
const populations = computed(() => store.getters['qvctPopulation/getQvctpPopulations'])
watch(() => survey.value, () => {
  if(survey) {
    initSurveyData()
  }
})

function initSurveyData() {
  formData.value.id = survey.value.id
  formData.value.name = survey.value.name
  formData.value.questions = survey.value.questions
  formData.value.description = survey.value.description
  formData.value.start_date = survey.value.start_date
  formData.value.end_date = survey.value.end_date
  formData.value.population_ids = Array.isArray(survey.value.populations)
      ? survey.value.populations.map(p => p.id)
      : []
}


function loadData() {
  Promise.all([
    store.dispatch('qvctPopulation/loadQvctPopulation'),
  ])
}


onMounted(() => {
  initSurveyData()
  loadData()
})

function openCreatePopulationModal(){
  $('#kt_modal_create_qvct_population').modal('toggle')
}

function reload(population){
  loadData()
  formData.value.population_ids.push(population)
}

function submitSurvey() {
  isLoading.value = true

  store.dispatch('qvctSurvey/updateSurvey', formData.value)
      .then(() => {
        window.toastr.success(i18n.global.t('qvct_survey.message.survey_updated_successfully'))
        isLoading.value = false
      })
      .catch(() => {
        isLoading.value = false
      })
}
</script>